// Action Types
export const SHOW_LOADING_SPINNER = 'TEAM_NAME_GENERATOR/SHOW_LOADING_SPINNER';
export const SET_GENERATED_TEAM_NAMES = 'TEAM_NAME_GENERATOR/SET_GENERATED_TEAM_NAMES';

// Action Creator
const TeamNameGeneratorActions = {
  setGeneratedTeamNames(names: any) {
    return {
      type: SET_GENERATED_TEAM_NAMES,
      payload: names
    };
  },

  showLoadingSpinner(show: boolean) {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: show
    };
  }
};

export default TeamNameGeneratorActions;
